import uuid from 'uuid/v4'

const propagate = (menus, propagateRole = undefined) => {
  return menus.map((menu) => {
    menu.id = uuid()
    if (!menu.role) {
      menu.role = propagateRole
    }
    if (menu.children) {
      menu.chidren = propagate(menu.children, menu.role)
    }
    return menu
  })
}

export default {
  resolve(instance) {
    return propagate([
      {
        icon: 'fa-cubes',
        title: instance.$t('supplier_pl.title'),
        children: [
          {
            title: instance.$t('supplier_pl_list.menu'),
            to: 'supplier_pl_list'
          },
          {
            title: instance.$t('supplier_pl_column.menu'),
            to: 'supplier_pl_column'
          },
          {
            title: instance.$t('supplier_variety.title'),
            to: 'supplier_variety'
          },
          {
            title: instance.$t('supplier_size.title'),
            to: 'supplier_size'
          },
          {
            title: instance.$t('supplier_box_type.title'),
            to: 'supplier_box_type'
          },
          {
            title: instance.$t('supplier_unit.title'),
            to: 'supplier_unit'
          }
        ],
        role: 'supplier',
        displayOrder: 1001
      },
      {
        icon: 'fa-cube',
        title: instance.$t('pl_menu'),
        children: [
          {
            title: instance.$t('pl_fetch.title'),
            to: 'pl_fetch'
          },
          {
            title: instance.$t('import_api.title'),
            to: 'import_api'
          }
        ],
        role: 'user',
        displayOrder: 1101
      },
      {
        icon: 'fa-money',
        title: instance.$t('sales'),
        children: [
          {
            title: instance.$t('stock.title'),
            to: 'stock_input'
          },
          {
            title: instance.$t('regular.list'),
            to: 'regular'
          },
          {
            title: instance.$t('regular_allocation.title'),
            to: 'regular_allocation'
          },
          {
            title: instance.$t('chart_list.title'),
            to: 'chart_list'
          },
          {
            title: instance.$t('invoice_print.title'),
            to: 'invoice_print'
          },
          {
            title: instance.$t('order_receipt.menu'),
            to: 'order_receipt'
          },
          {
            title: instance.$t('invoice_transmission.title'),
            to: 'invoice_transmission'
          },
          {
            title: instance.$t('logi_center_forward.title'),
            to: 'logi_center_forward'
          },
          {
            title: instance.$t('chart_output.title'),
            to: 'chart_output'
          },
          {
            title: instance.$t('sales_report.title'),
            to: 'sales_report'
          },
          {
            title: instance.$t('flash_report.title'),
            to: 'flash_report'
          }
        ],
        role: 'user',
        displayOrder: 1201
      },
      {
        icon: 'fa-comments',
        title: instance.$t('claim_menu'),
        children: [
          {
            title: instance.$t('customer_claim.title'),
            to: 'customer_claim'
          },
          {
            title: instance.$t('customer_claim_view.title'),
            to: 'customer_claim_view'
          },
          {
            title: instance.$t('claim_report.title'),
            to: 'claim_report'
          }
        ],
        role: 'user',
        displayOrder: 1301
      },
      {
        icon: 'fa-newspaper-o',
        title: instance.$t('journal'),
        children: [
          {
            title: instance.$t('journal_search.title'),
            to: 'journal_search'
          },
          {
            title: instance.$t('journal_aggregator.title'),
            to: 'journal_aggregator'
          },
          {
            title: instance.$t('journal_country.title'),
            to: 'journal_country'
          }
        ],
        role: 'user',
        displayOrder: 1401
      },
      {
        icon: 'fa-bar-chart',
        title: instance.$t('statistic_menu'),
        children: [
          {
            title: instance.$t('product_statistic.title'),
            to: 'product_statistic'
          },
          {
            title: instance.$t('customer_summary.title'),
            to: 'customer_summary'
          },
          {
            title: instance.$t('item_ranking.title'),
            to: 'item_ranking'
          },
          {
            title: instance.$t('market_flash.title'),
            to: 'market_flash'
          }
        ],
        role: 'user',
        displayOrder: 1501
      },
      {
        icon: 'fa-calculator',
        title: instance.$t('finance'),
        children: [
          {
            title: instance.$t('shipment_menu'),
            children: [
              {
                title: instance.$t('bp.title'),
                to: 'bp'
              },
              {
                title: instance.$t('kshipment.title'),
                to: 'Kshipment'
              },
              {
                title: instance.$t('finance_tofill.title'),
                to: 'finance_tofill'
              }
            ]
          },
          {
            title: instance.$t('sales'),
            children: [
              {
                title: instance.$t('sales_amount_status.title'),
                to: 'sales_amount_status'
              },
              {
                title: instance.$t('urizan.title'),
                to: 'urizan'
              },
              {
                title: instance.$t('sales_difference.title'),
                to: 'sales_difference'
              },
              {
                title: instance.$t('stock_remaining.title'),
                to: 'stock_remaining'
              },
              {
                title: instance.$t('sales_view.title'),
                to: 'sales_view'
              }
            ]
          },
          {
            title: instance.$t('bill_receipt_menu'),
            children: [
              {
                title: instance.$t('receipt.title'),
                to: 'receipt'
              },
              {
                title: instance.$t('receipt_check.title'),
                to: 'receipt_check'
              },
              {
                title: instance.$t('receipt_view.title'),
                to: 'receipt_view'
              },
              {
                title: instance.$t('sales_input.title'),
                to: 'sales_input'
              },
              {
                title: instance.$t('bill_document.title'),
                to: 'bill_document'
              },
              {
                title: instance.$t('bill_closing.title'),
                to: 'bill_closing'
              },
              {
                title: instance.$t('bill_print.title'),
                to: 'bill_print'
              },
              {
                title: instance.$t('bill_list.title'),
                to: 'bill_list'
              },
              {
                title: instance.$t('finance_unpaid.title'),
                to: 'finance_unpaid'
              },
              {
                title: instance.$t('motochou.title'),
                to: 'motochou'
              }
            ]
          },
          {
            title: instance.$t('statement.payment'),
            children: [
              {
                title: instance.$t('statement.title'),
                to: 'statement'
              },
              {
                title: instance.$t('fumigation_request.title'),
                to: 'fumigation_request'
              }
            ]
          },
          {
            title: instance.$t('monthly_menu'),
            children: [
              {
                title: instance.$t('balance_management.title'),
                to: 'customer_balance_management'
              },
              {
                title: instance.$t('customer_balance.title'),
                to: 'customer_balance'
              }
            ]
          }
        ],
        role: 'user',
        displayOrder: 1601
      },
      {
        icon: 'fa-bell-o',
        title: instance.$t('contact.title'),
        children: [
          {
            title: instance.$t('contact.list'),
            to: 'contact'
          }
        ],
        role: 'user',
        displayOrder: 1701
      },
      {
        icon: 'fa-cogs',
        title: instance.$t('master_maintenance'),
        children: [
          {
            title: instance.$t('management_menu'),
            children: [
              {
                title: instance.$t('setting.title'),
                to: 'setting'
              },
              {
                title: instance.$t('country.title'),
                to: 'country'
              },
              {
                title: instance.$t('currency.title'),
                to: 'currency'
              },
              {
                title: instance.$t('region.title'),
                to: 'region'
              },
              {
                title: instance.$t('port.title'),
                to: 'port'
              },
              {
                title: instance.$t('options_bp.title'),
                to: 'options_bp'
              },
              {
                title: instance.$t('options_pq.title'),
                to: 'options_pq'
              },
              {
                title: instance.$t('contact_type.title'),
                to: 'contact_type'
              },
              {
                title: instance.$t('contact_status.title'),
                to: 'contact_status'
              },
              {
                title: instance.$t('filetype.title'),
                to: 'filetype'
              },
              {
                title: instance.$t('tax_rate.title'),
                to: 'tax_rate'
              }
            ]
          },
          {
            title: instance.$t('goods_menu'),
            children: [
              {
                title: instance.$t('genus_title'),
                to: 'genus'
              },
              {
                title: instance.$t('item_title'),
                to: 'item'
              },
              {
                title: instance.$t('variety_title'),
                to: 'variety'
              },
              {
                title: instance.$t('size_title'),
                to: 'size'
              },
              {
                title: instance.$t('option_title'),
                to: 'option'
              },
              {
                title: instance.$t('unit.title'),
                to: 'unit'
              },
              {
                title: instance.$t('worm.title'),
                to: 'worm'
              },
              {
                title: instance.$t('repack_preset.title'),
                to: 'repack_preset'
              },
              {
                title: instance.$t('repack_line.title'),
                to: 'repack_line'
              },
              {
                title: instance.$t('repack_place.title'),
                to: 'repack_place'
              },
              {
                title: instance.$t('excel_to_stock.title'),
                to: 'excel_to_stock'
              }
            ]
          },
          {
            title: instance.$t('regular.title'),
            children: [
              {
                title: instance.$t('regular_cycle.title'),
                to: 'regular_cycle'
              }
            ]
          },
          {
            title: instance.$t('box_type.title'),
            children: [
              {
                title: instance.$t('box_type.title'),
                to: 'box_type'
              },
              {
                title: instance.$t('box_type_dicision.title'),
                to: 'box_type_dicision'
              }
            ]
          },
          {
            title: instance.$t('finance_tofill.list.fumigation'),
            children: [
              {
                title: instance.$t('fumigation_company.title'),
                to: 'fumigation_company'
              },
              {
                title: instance.$t('fumigation_company_port.title'),
                to: 'fumigation_company_port'
              },
              {
                title: instance.$t('fumigation_type.title'),
                to: 'fumigation_type'
              }
            ]
          },
          {
            title: instance.$t('carry_out_menu'),
            children: [
              {
                title: instance.$t('uwaya.title'),
                to: 'uwaya'
              },
              {
                title: instance.$t('uwaya_port.title'),
                to: 'uwaya_port'
              },
              {
                title: instance.$t('hanshutsu_status.title'),
                to: 'hanshutsu_status'
              },
              {
                title: instance.$t('awb_to_uwaya.title'),
                to: 'awb_to_uwaya'
              }
            ]
          },
          {
            title: instance.$t('delivery_menu'),
            children: [
              {
                title: instance.$t('forward.title'),
                to: 'forward'
              },
              {
                title: instance.$t('delivery_area.title'),
                to: 'delivery_area'
              },
              {
                title: instance.$t('delivery_company.title'),
                to: 'delivery_company'
              },
              {
                title: instance.$t('delivery_unit_cost.title'),
                to: 'delivery_unit_cost'
              },
              {
                title: instance.$t('logi_center.title'),
                to: 'logi_center'
              }
            ]
          },
          {
            title: instance.$t('customer.title'),
            children: [
              {
                title: instance.$t('customer.title'),
                to: 'customer'
              },
              {
                title: instance.$t('customer_common_holiday.title'),
                to: 'customer_common_holiday'
              },
              {
                title: instance.$t('customer_holiday.title'),
                to: 'customer_holiday'
              }
            ]
          },
          {
            title: instance.$t('bill_master_menu'),
            children: [
              {
                title: instance.$t('bill_closing_pattern.title'),
                to: 'bill_closing_pattern'
              },
              {
                title: instance.$t('bill_item.title'),
                to: 'bill_item'
              },
              {
                title: instance.$t('bill_balance.title'),
                to: 'bill_balance'
              }
            ]
          },
          {
            title: instance.$t('supply_menu'),
            children: [
              {
                title: instance.$t('supplier.title'),
                to: 'supplier'
              },
              {
                title: instance.$t('supplier_required.title'),
                to: 'supplier_required'
              }
            ]
          },
          {
            title: instance.$t('notification_menu'),
            children: [
              {
                title: instance.$t('notification_type.title'),
                to: 'notification_type'
              }
            ]
          },
          {
            title: instance.$t('statement.payment'),
            children: [
              {
                title: instance.$t('payee.title'),
                to: 'payee'
              },
              {
                title: instance.$t('beneficiary_bank.title'),
                to: 'beneficiary_bank'
              },
              {
                title: instance.$t('beneficiary_bank_branch.title'),
                to: 'beneficiary_bank_branch'
              },
              {
                title: instance.$t('payee_bank.title'),
                to: 'payee_bank'
              },
              {
                title: instance.$t('payment_reason.title'),
                to: 'payment_reason'
              },
              {
                title: instance.$t('classification.title'),
                to: 'classification'
              },
              {
                title: instance.$t('payment_closing_pattern.title'),
                to: 'payment_closing_pattern'
              },
              {
                title: instance.$t('bank.title'),
                to: 'bank'
              },
              {
                title: instance.$t('bank_branch.title'),
                to: 'bank_branch'
              },
              {
                title: instance.$t('statement_balance.title'),
                to: 'statement_balance'
              }
            ]
          },
          {
            title: instance.$t('temperature_menu'),
            children: [
              {
                title: instance.$t('temperature.title'),
                to: 'temperature'
              },
              {
                title: instance.$t('temperature_preset.title'),
                to: 'temperature_preset'
              },
              {
                title: instance.$t('temperature_state.title'),
                to: 'temperature_state'
              }
            ]
          },
          {
            title: instance.$t('domestic_production_menu'),
            children: [
              {
                title: instance.$t('dp_maker.title'),
                to: 'dp_maker'
              }
            ]
          },
          {
            title: instance.$t('fm_selling_status.title'),
            children: [
              {
                title: instance.$t('fm_selling_status.management'),
                to: 'fm_selling_status'
              }
            ]
          },
          {
            title: instance.$t('stock_status.title'),
            children: [
              {
                title: instance.$t('stock_status.management'),
                to: 'stock_status'
              }
            ]
          },
          {
            title: instance.$t('damage_type.title'),
            children: [
              {
                title: instance.$t('damage_type.management'),
                to: 'damage_type'
              }
            ]
          }
        ],
        role: 'manager',
        displayOrder: 2001
      }
    ])
  }
}



// WEBPACK FOOTER //
// ./src/app/menus.js